import React from 'react';
import { UserProfile, Client } from '@/shared/types';

interface TemplateProps {
  profile: UserProfile;
  client?: Client | null;
  title: string;
  metaData: { label: string; value: string }[];
  children: React.ReactNode;
  footerNote?: string;
  type: string;
  containerClass: string;
  LogoImage: React.FC<{ size: 'sm' | 'md' | 'lg' | 'xl'; className?: string; light?: boolean }>;
  hideHeader?: boolean;
}

const MonochromeTemplate: React.FC<TemplateProps> = ({
  profile, client, title, metaData, children, footerNote, type, containerClass, LogoImage, hideHeader = false
}) => {
  return (
    <div className={containerClass}>
       {!hideHeader && (
         <>
           <div className="bg-black text-white p-12 flex justify-between items-end">
               <div>
                   <h1 className="text-4xl font-bold mb-1 tracking-tight">{profile.name}</h1>
                   <p className="text-sm text-gray-400">{profile.address}</p>
               </div>
               <div className="text-right">
                   <h2 className="text-6xl font-black tracking-tighter opacity-20">{type}</h2>
                   <div className="bg-white text-black font-bold px-2 py-1 inline-block text-sm">{title}</div>
               </div>
           </div>

           <div className="p-12 flex-1 flex flex-col">
               <div className="grid grid-cols-2 gap-12 border-b-4 border-black pb-12 mb-12">
                   <div>
                       <p className="font-bold border-b-2 border-black inline-block mb-4">CLIENT</p>
                       {client ? (
                           <div className="text-lg">
                               <p className="font-bold">{client.name}</p>
                               <p>{client.company}</p>
                               <p className="text-sm mt-1 text-gray-500">{client.email}</p>
                           </div>
                       ) : <span className="text-gray-300">N/A</span>}
                   </div>
                   <div className="grid grid-cols-2 gap-4">
                       {metaData.map((m, i) => (
                           <div key={i}>
                               <p className="text-xs text-gray-500 uppercase">{m.label}</p>
                               <p className="font-bold text-lg">{m.value}</p>
                           </div>
                       ))}
                   </div>
               </div>
           </div>
         </>
       )}

       <div className="p-12 flex-1 flex flex-col">
           <div className="flex-1 monochrome-table">
               {children}
           </div>

           <div className="mt-auto border-t border-black pt-4 flex justify-between text-xs font-bold uppercase">
               <span>{footerNote}</span>
               <span>Page 1 of 1</span>
           </div>
       </div>
    </div>
  );
};

export default MonochromeTemplate;